import { render, staticRenderFns } from "./create-prize.vue?vue&type=template&id=5c68f376&"
import script from "./create-prize.vue?vue&type=script&lang=js&"
export * from "./create-prize.vue?vue&type=script&lang=js&"
import style0 from "./create-prize.vue?vue&type=style&index=0&id=5c68f376&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports